import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSerializer } from '@angular/router';

import { BusinessIntelligenceService } from 'src/app/services/business-intelligence/business-intelligence.service';
import { ManualOrderService } from 'src/app/services/manual-order/manual-order.service';

@Component({
  selector: 'app-prosumer',
  templateUrl: './prosumer.component.html',
  styleUrls: ['./prosumer.component.scss']
})
export class ProsumerComponent implements OnInit {

  // catalog_nav = [
  //   {
  //     'label': 'DJI Flip',
  //     'link': 'dji_flip',
  //     'icon': 'https://www-cdn.djiits.com/dps/991a1f0d628b663e4005ce176ceaee1c.png'
  //   },
  //   {
  //     'label': 'DJI Mavic',
  //     'link': 'dji_mavic',
  //     'icon': 'https://www-cdn.djiits.com/dps/3b7953435e791d6a56253d87584e34cf.png'
  //   },
  //   {
  //     'label': 'DJI Air',
  //     'link': 'dji_air',
  //     'icon': 'https://www-cdn.djiits.com/dps/77738ff32f7a228fc58b4f401261e481.png'
  //   },
  //   {
  //     'label': 'DJI Mini',
  //     'link': 'dji_mini',
  //     'icon': 'https://www-cdn.djiits.com/dps/5698cb42a9a1fdce69e22f30550d9767.png'
  //   },
  //   {
  //     'label': 'DJI Neo',
  //     'link': 'dji_neo',
  //     'icon': 'https://www-cdn.djiits.com/dps/3bc0c60f6d8b87c1ebb733603ddeb546.png'
  //   },
  //   {
  //     'label': 'DJI Avata',
  //     'link': 'dji_avata',
  //     'icon': 'https://www-cdn.djiits.com/dps/97e1b5ab20211e739898969647666de1.png'
  //   },
  //   {
  //     'label': 'DJI Inspire',
  //     'link': 'dji_inspire',
  //     'icon': 'https://www-cdn.djiits.com/dps/d13ba498aecd93533f69bcd1500458af.png'
  //   },
  //   {
  //     'label': 'RC',
  //     'link': 'dji_rc',
  //     'icon': 'https://www-cdn.djiits.com/dps/b429552c65fa90e612204031c752b2e0.png'
  //   },
  //   {
  //     'label': 'Power',
  //     'link': 'dji_power',
  //     'icon': 'https://www-cdn.djiits.com/dps/f14c7c1d91574014937b8f52e8226e1a.png'
  //   },

  //   {
  //     'link': 'dji_accesories',
  //     'label': 'DJI Accesories',
  //     'icon': 'https://www-cdn.djiits.com/dps/b0e6c88f2943a03d8169310748a03085.png'

  //   },
  // ]
  selected_item: any;
  active_nav: any;
  params: string;
  products: any;
  type: string;
  category: string;
  cat_id: string;
  catalog_nav: any;
  parrent_id: string;
  child_id: string;
  landing_page: any;
  isLoading: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: BusinessIntelligenceService,
    private webService: ManualOrderService,
    private serializer: UrlSerializer,

  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      console.log('hihi')
      window.scroll({
        top: 0,
        left: 0,

      });



    })



    this.route.queryParamMap.subscribe(queryParams => {
      this.parrent_id = queryParams.get("parrent_id")
      this.child_id = queryParams.get("child_id")

      this.type = queryParams.get("type")

      this.getCategory(this.parrent_id)
      if (this.child_id) {
        this.selectCategoryProduct(this.child_id)

      }



    })
  }
  async getCategory(id: string) {
    try {
      let response = await this.webService.getCategory('?parrent_id=' + id);
      console.log(response);
      console.log('check here');
      this.landing_page = response.parrent
      this.catalog_nav = response.data;

      // ✅ Check for first_child from response
      if (!this.child_id && response.first_child) {
        this.child_id = response.first_child;
        // Optionally: immediately load products for this first child
        await this.selectCategoryProduct(this.child_id);
      }

    } catch (e) {
      console.log(e);
    }
  }





  async selectCategoryProduct(id) {
    try {
      this.isLoading = true
      this.products = []

      let response = await this.webService.getCategoryProduct(id)
      // console.log(response)
      console.log('selectCategoryProduct')
      this.products = response.data
      console.log(this.products)
    } catch (e) {
      console.log(e)
    } finally {
      this.isLoading = false



    }
  }
  navigateTo(item) {
    this.router.navigate(
      [],
      {
        queryParams: { child_id: item.id },
        queryParamsHandling: 'merge'
      }
    );
    this.active_nav = item;
  }


  selectItem(item) {
    this.selected_item = item
  }

}
